module.exports = __webpack_public_path__ + "img/voucher.c5b56272.png";